import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BookWidgetFieldInfoModal } from '../../../../models/book-widget-aem.interfaces';
import { ErrorStateDirective } from '../../directive';
import {
  InfoTooltipMachCoreComponent,
  LimitedTooltipOptions
} from '../info-tooltip-mach-core/info-tooltip-mach-core.component';

@Component({
  standalone: true,
  selector: 'idp-meeting-code-mach-core',
  templateUrl: './meeting-code-mach-core.component.html',
  imports: [InfoTooltipMachCoreComponent, NgIf, NgClass, ErrorStateDirective],
  styleUrls: ['./meeting-code-mach-core.component.scss']
})
export class MeetingCodeMachCoreComponent {
  @Input() placeholder = '';
  @Input() title = '';
  @Input() value = '';
  @Input() errorMessage? = '';
  @Input() disclaimerMessage = '';
  @Input() disabled = false;
  @Input() infoModalContent!: BookWidgetFieldInfoModal;
  @Input() tooltipOptions!: LimitedTooltipOptions;
  @Input() triggerIcon =
    '/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg';

  @Output() valueChange = new EventEmitter<Event>();
}
